<div class="certificate-container" dir="rtl">
  <div class="form-wrapper">
    <!-- Main Title -->
    <div class="main-title">
      <h2>شهادة تكويد الأسهم الصادرة من مصر المقاصة</h2>
    </div>

    <!-- Form Section -->
    <div class="form-section">
      <form [formGroup]="documentForm" class="input-file" (ngSubmit)="onSave()">
        <fieldset [disabled]="isReadOnly" class="readonly-fieldset">
          <app-file-upload
            label="شهادة تكويد الأسهم الصادرة من مصر المقاصة"
            [required]="true"
            tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF"
            acceptedTypes=".pdf"
            errorMessage="يرجى تحميل شهادة تكويد الأسهم الصادرة من مصر المقاصة (PDF فقط)"
            formControlName="idDocument"
            [filePath]="filePath"
            (uploadComplete)="onUploadComplete($event)"
            (fileRemoved)="onFileRemoved()"
          ></app-file-upload>
        </fieldset>
      </form>
    </div>
  </div>
</div>
